import { useNavigate } from "react-router-dom";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";

export default function Intro() {
    const navigate = useNavigate();

    return (
        <div>
            <div className="flex justify-end items-center">
                <div className="xs:w-52 md:w-full max-w-xs">
                    <Progressbar percentage={"0"} />
                </div>
            </div>
            <Box>
                <h2>Innan ni börjar er anmälan</h2>
                <p>Tack för att ni väljer att resa
                    hållbart. Innan ni påbörjar er anmälan finns det några viktiga saker att känna till om gruppresor;</p>

                <ul>
                    <li>
                        Resan behöver anmälas minst fem dagar i förväg.
                    </li>
                    <li>
                        Vi kan inte garantera en plats på turen trots föranmälan.
                    </li>
                    <li>
                        Ni behöver själva hålla koll på om avgångstiden för turen ändras. Det gör ni genom att söka resan i appen eller på webben.</li>
                    <li>
                        Eventuell barnvagn och/eller rullstol tas med i mån av plats.</li>
                    <li>
                        Är ni en skolklass som reser rekommenderar vi en Kulturbiljett. Den köper ni i vår
                        företagsportal. Vi hjälper er dit när ni skickat in er anmälan.
                    </li>
                </ul>
                <p>
                    Om ni stöter på frågor längs vägen är ni välkomna att höra av er till vår kundservice på <a href="tel:0771-21 10 10">0771-21 10 10</a>.
                </p>

            </Box>

            <div className="flex justify-center">
                <div className="w-full text-right">
                    <button
                        onClick={() => navigate("/vart-vill-ni-resa")}
                        className="btn primary"
                        type="submit"
                    >
                        Anmäl gruppresa
                    </button>
                </div>
            </div>
        </div>
    );
}
